import { MONTHLY_COMMISSIONS_ENDPOINT } from '../../endpoints'
import axios from 'axios'

export async function updateCommissionMonth(id, body) {
    const response = await axios.put(MONTHLY_COMMISSIONS_ENDPOINT + `/${id}`, body);
    return response
}